'use strict';

import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import ContactForm from 'Components/Forms/ContactForm';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
let app = typeof window !== 'undefined' ? window.app : undefined;
window.React = React;
export default class HotelPage extends Component {
  state = {
    loading: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPage();
  }
  fetchPage = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/fetch-page-infos', {
      url: document.location.pathname,
      type: 'page'
    }).then(function (xhr, response) {
      component.setState({
        ...response,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement(ContactForm, null));
    return output;
  }
}
